import React from "react";
// import { useParams } from 'react-router-dom';
import { Box } from "@mui/material";
import MrqSelector from "./components/MrqSelector";
import MrqDetails from "./components/MrqDetails";
import MrqMaterialsTable from "./components/MrqMaterialsTable";
import LabelledBox from "../../../../../../components/widgets/LabelledBox";
import { useMrqContext } from "./MrqContext";

export default function Main() {
  const { mrqList, mrqSelection, setMrqSelection, setSelectedMrqData } =
    useMrqContext();

  return (
    <Box>
      <LabelledBox label="MRQ Manager">
        <MrqSelector
          mrqList={mrqList}
          mrqSelection={mrqSelection}
          setMrqSelection={setMrqSelection}
          setSelectedMrqData={setSelectedMrqData}
        />
      </LabelledBox>
      <MrqDetails />
      <MrqMaterialsTable />{" "}
      {/* <AddDataDialog open={dialog.open} onClose={onClose} /> */}
    </Box>
  );
}
